module.exports = __webpack_public_path__ + "img/Iconen Class Action website-06.20fe7aaa.svg";